import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';

export function getAppMaterialDateProviders() {
  return [provideNativeDateAdapter(), { provide: MAT_DATE_LOCALE, useValue: 'en-CA' }];
}
